import React from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';

import { useAndroidRerenderOnAppStateChange } from '@/components/player-profile/hooks/use-skia-image-cache';
import {
    CONTAINER_SIZE,
    PADDING_HORIZONTAL,
    PADDING_RIGHT_PLAYER_IMAGE,
} from '@/feature/player-profile-sheets/utils/player-profile-utils';
import { designSystem } from '@/styles/styles';
import { BlurMask, Canvas, Group, Mask, Rect, SkFont, Text as SkiaText, useFont } from '@shopify/react-native-skia';

const TEXT_CONTAINER_HEIGHT = 36;
const TEXT_SIZE = 30;

export const PlayerLastNameWithMask = ({ lastName }: { lastName: string }) => {
    const { width: screenWidth } = useWindowDimensions();

    const font = useFont(require('../../../assets/fonts/gamay-extrabold.ttf'), TEXT_SIZE);
    const padding = 16;

    useAndroidRerenderOnAppStateChange();

    if (!font) {
        return null;
    }

    const textWidth = font.measureText(lastName).width;
    const textAvailableWidth =
        screenWidth - (CONTAINER_SIZE.width + PADDING_RIGHT_PLAYER_IMAGE + 2 * PADDING_HORIZONTAL);

    const needsRightMask = textWidth > textAvailableWidth;
    const needsLeftMask = needsRightMask && textWidth > screenWidth - textAvailableWidth;
    const noNeedForMask = !needsLeftMask && !needsRightMask;

    return (
        <Canvas style={styles.canvas}>
            {noNeedForMask ? (
                <PlayerName lastName={lastName} font={font} />
            ) : (
                <Group>
                    <Mask
                        mode="alpha"
                        mask={
                            <Group>
                                {needsRightMask ? (
                                    <Rect
                                        x={-16}
                                        y={0}
                                        width={textAvailableWidth + padding + 20}
                                        height={TEXT_CONTAINER_HEIGHT}
                                        color={designSystem.colors.white}
                                    >
                                        <BlurMask blur={10} style="normal" />
                                    </Rect>
                                ) : null}

                                {needsLeftMask ? (
                                    <Rect
                                        x={textAvailableWidth + CONTAINER_SIZE.width - 22}
                                        y={0}
                                        width={textAvailableWidth + CONTAINER_SIZE.width}
                                        height={TEXT_CONTAINER_HEIGHT}
                                        color={designSystem.colors.white}
                                    >
                                        <BlurMask blur={10} style="normal" />
                                    </Rect>
                                ) : null}
                            </Group>
                        }
                    >
                        <PlayerName lastName={lastName} font={font} />
                    </Mask>
                </Group>
            )}
        </Canvas>
    );
};

const PlayerName = ({ lastName, font }: { lastName: string; font: SkFont }) => {
    return <SkiaText x={0} y={TEXT_SIZE} text={lastName.toUpperCase()} font={font} color={designSystem.colors.white} />;
};

const styles = StyleSheet.create({
    canvas: {
        height: TEXT_CONTAINER_HEIGHT,
    },
});
